import { css } from 'styled-components';

export type GridAreaType = { gridArea?: string };

export const gridAreaStyle = css<GridAreaType>`
    ${({ gridArea }) => gridArea && `grid-area: ${gridArea};`}
`;
